import { Component, OnInit, OnDestroy, ViewEncapsulation, HostListener } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { Subject, Subscription, takeUntil, combineLatest, forkJoin } from 'rxjs';

import { ExpediteurpopupComponent } from './expediteurpopup/expediteurpopup.component';
import { ListepopupComponent } from 'src/app/shared/components/listepopup/listepopup.component';
import { SharedUtilsService } from 'src/app/core/services/shared-utils.service';
import { CommandeService } from 'src/app/core/services/commande.service';
import { AuthService } from 'src/app/core/services/auth.service';

import { finalize } from 'rxjs';
import { ArticlepopupComponent } from './articlepopup/articlepopup.component';
import { ReferenceDataService } from 'src/app/core/services/referencedata.service';
import { ExpediteurDto } from 'src/app/shared/interfaces/dtos/expediteur-dto';
import { DestinataireDto } from 'src/app/shared/interfaces/dtos/destinataire-dto';
import { DestinatairepopupComponent } from './destinatairepopup/destinatairepopup.component';
import { MessageService } from 'src/app/core/services/message.service';
import { ToastService } from 'src/app/core/services/toast.service';
import { TypeEnvoi, TYPE_ENVOI_URBAIN, TYPE_ENVOI_INTERURBAIN } from 'src/app/core/enumerateurs/type-envoi';
import { ModePaiement } from 'src/app/core/enumerateurs/mode-paiement';
import { MoyenTransport } from 'src/app/core/enumerateurs/moyen-transport';
import { AdressesListepopupComponent } from 'src/app/shared/components/adresseslistepopup/adresseslistepopup.component';
import { MapDialogComponent } from 'src/app/shared/components/map-dialog/map-dialog.component';
import { TarifConfigurationDTO } from 'src/app/shared/interfaces/dtos/tarif-configuration-dto';
import { TarifConfigurationService } from 'src/app/core/services/tarif-configuration.service';
import { SseNotificationService } from 'src/app/core/services/sse-notification.service';
import { environment } from 'src/environments/environment';
import { UtilisateurService } from 'src/app/core/services/utilisateur.service';

@Component({
  selector: 'app-enregistrer-commande',
  templateUrl: './commande.component.html',
  styleUrls: ['./commande.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class CommandeComponent implements OnInit, OnDestroy {

  commandeForm!: FormGroup;

  private destroy$ = new Subject<void>();
  private sseMajSub?: Subscription;
  commandeId: number | null = null;


  textHeading = 'Commandes';
  textBody = 'Enregistrer une Commande';

  expediteur: ExpediteurDto = {};
  destinataire: DestinataireDto = {};
  contactData = {};
  articlesCmd!: any;
  estEnChargement = false;
  voirBtnEnregistrer = true;
  estModeConsultation = false;

  typeEnvoiOptions: { label: string, value: string }[] = [];
  modePaiementOptions: { label: string, value: string }[] = [];
  moyenTransportOptions: { label: string, value: string }[] = [];

  /** 'urbain' | 'interurbain' | null — déterminé par le query param ?mode= */
  modeCommande: 'urbain' | 'interurbain' | null = null;
  clientsOptions: any[] = [];
  clientsFiltres: any[] = [];
  clientSelectionne: any = null;
  rechercheClient = '';
  dropdownClientOuvert = false;

  adresse: string = "";
  readonly dateMinEnlevement: Date = new Date();
  commandeDetail: any = null; // données brutes de la commande (photo livraison, livreur, dates…)

  tarifConfigurationDTO: TarifConfigurationDTO = {};
  trajetLibelle = '';
  photoLivraisonErreurChargement = false;
  panelAffectationOuvert = false;
  rechercheLivreur = '';
  chargementLivreurs = false;
  assignationEnCours = false;
  livreursPanel: any[] = [];
  livreursPanelFiltres: any[] = [];
  montantContrat: number | null = null;
  modeDescriptionLibre = false;
  descriptionLibreTexte = '';

  /** Incidents / réclamations liés à cette commande */
  incidentsCommande: any[] = [];
  incidentsEnChargement = false;

  carteSheetVisible = false;

  ouvrirSheetCarte(): void {
    this.carteSheetVisible = true;
    document.body.style.overflow = 'hidden';
  }

  fermerSheetCarte(): void {
    this.carteSheetVisible = false;
    document.body.style.overflow = '';
  }

  photoApercuUrl: string | null = null;
  photoApercuIndex = -1;
  modeEditionArticles = false;
  sauvegarderArticlesEnCours = false;
  private articlesSnapshot: any[] = [];
  fichiersProcess: Record<string, File | null> = {
    RECUPERATION: null,
    EXPEDITION_CENTRE: null,
    RECEPTION_CENTRE: null,
    LIVRAISON: null
  };
  uploadProcessEnCours: Record<string, boolean> = {
    RECUPERATION: false,
    EXPEDITION_CENTRE: false,
    RECEPTION_CENTRE: false,
    LIVRAISON: false
  };

  colonnesAffichees = [
    { field: 'typeArticle',  name: 'Type', class: 'cashier-addsale-product-date' },
    { field: 'typeConditionnement',  name: 'Conditionement', class: 'cashier-addsale-product-Products' },
    { field: 'description',  name: 'Description', class: 'cashier-addsale-product-Products' },
    { field: 'dimensions',  name: 'L x l (Cm)', class: 'cashier-addsale-product-unit' },
    { field: 'hauteur',  name: 'Hauteur (Cm)', class: 'cashier-addsale-product-unit' },
    { field: 'poids',  name: 'Poids (Kg)', class: 'cashier-addsale-product-unit' },
    { field: 'quantite',  name: 'Quantité', class: 'cashier-addsale-product-qty' },
    { field: 'prixUnitaire',  name: 'Prix Unitaire', class: 'cashier-addsale-product-price' },
    { field: '',  name: 'Action', class: 'cashier-addsale-product-date' }
  ];

  colonnesContactsAffichees = [
    { field: 'nom',  name: 'Nom', style: 'text-align: left;' },
    { field: 'prenom',  name: 'Prémons', style: 'text-align: left;' },
    { field: 'telephone',  name: 'Téléphone', style: 'text-align: center;' },
  ];

  colonnesTrajetsAffichees = [
    { field: 'zoneDepartNom',  name: 'Zone de départ', width: 'width: 25%;' },
    { field: 'zoneDestinationNom',  name: 'Zone de destination', width: 'width: 25%;' },
    { field: 'distanceKm',  name: 'Distance en Km', width: 'width: 15%;' },
    { field: '',  name: '', width: 'width: 5%;' }
  ];

  constructor(private fb: FormBuilder
    , public dialog: MatDialog
    , private router : Router
    , private route: ActivatedRoute
    , public commandeService: CommandeService
    , private referenceDataService: ReferenceDataService
    , private tarifConfigurationService: TarifConfigurationService
    , private messageService: MessageService
    , private toastService: ToastService
    , public sharedUtilsService: SharedUtilsService
    , private authService: AuthService
    , private sse: SseNotificationService
    , private utilisateurService: UtilisateurService
  ) {
  }

  ngOnInit(): void {

  // Combiner paramMap et queryParams pour déterminer le mode
  combineLatest([this.route.paramMap, this.route.queryParams])
    .pipe(takeUntil(this.destroy$))
    .subscribe(([params, queryParams]) => {
      const idCommande = params.get('id');
      // Mode consultation si: query param mode=view OU commande existante (avec ID)
      this.estModeConsultation = queryParams['mode'] === 'view' || !!idCommande;

      // Mode urbain/interurbain depuis le query param ?mode=
      const modeParam = queryParams['mode'];
      const clientIdParam = queryParams['clientId'];
      if (modeParam === 'interurbain') {
        this.modeCommande = 'interurbain';
        this.textBody = 'Nouvelle commande interurbaine';
      } else if (modeParam === 'urbain') {
        this.modeCommande = 'urbain';
        this.textBody = 'Nouvelle commande urbaine';
      }
      if (clientIdParam && this.commandeForm) {
        this.commandeForm.patchValue({ clientId: Number(clientIdParam) }, { emitEvent: false });
      }

      if (this.estModeConsultation && modeParam !== 'interurbain' && modeParam !== 'urbain') {
        this.textBody = 'Détails de la Commande';
        this.voirBtnEnregistrer = false;
        this.route.snapshot.data['title'] = 'Détails de la commande';
      }

      // Recharger les options si le mode vient d'être résolu
      if (this.typeEnvoiOptions.length > 0) {
        this.chargerDonneesReference();
      }
    });

  this.commandeForm = this.fb.group({
      dateEnlevementPrev: [null],
      heureEnlevementPrev: [null],
      observations: [''],
      expediteurid: [null, Validators.required],
      expediteurNom: [{ value: undefined, disabled: true }, Validators.required],
      expediteurContact: [{ value: '', disabled: true }, Validators.required],
      lieuDepartTexte: ['', Validators.required],
      lieuDepartLongitude: [0.0],
      lieuDepartLatitude: [0.0],
      destinataireid: [null, Validators.required],
      destinataireNom: [{ value: undefined, disabled: true }, Validators.required],
      destinataireContact: [{ value: '', disabled: true }, Validators.required],
      flgTarifParZone: [false, Validators.required],
      lieuArriveeTexte: ['', Validators.required],
      lieuArriveeLongitude: [0.0],
      lieuArriveeLatitude: [0.0],
      trajetId: [null],
      longueurDuTrajet: [0],
      clientId: [null],
      contratBaseTarification: [''],
      contratTarificationParticuliere: [''],
      typeEnvoi: [null, [Validators.required]],
      modePaiement: [null, [Validators.required]],
      moyenTransport: [null, [Validators.required]],
      montantTotalForfait: [0, [Validators.required]],
      montantTotalSupplementaire: [0],
      montantRemise: [0],
      montantTotal: [0, [Validators.required]],
      statut: ['EN_ATTENTE'],
      articles: this.fb.array([])
    });

    const clientIdInitial = this.route.snapshot.queryParamMap.get('clientId');
    if (clientIdInitial) {
      this.commandeForm.patchValue({ clientId: Number(clientIdInitial) }, { emitEvent: false });
    }

    this.surveillanceArticle();
    this.surveillerRemise();

    this.articlesCmd = this.commandeForm.get('articles') as FormArray;
    this.chargerDonneesReference();
    this.chargerClients();
    this.chargerTarifConfiguration();
    this.ecouterTypeEnvoi();
    this.ecouterClientSelection();

    this.route.paramMap.subscribe(params => {
      const idCommande = params.get('id');
      if (idCommande) {
        this.commandeId = Number(idCommande);
        this.chargerCommande(this.commandeId);
        this.ecouterMisesAJourSSE();
      }
    });

    if (this.estModeConsultation) {
      this.desactiverFormulaire();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
    this.sseMajSub?.unsubscribe();
    document.body.classList.remove('overlay-panel-open');
  }

  private ecouterMisesAJourSSE(): void {
    this.sseMajSub?.unsubscribe();
    this.sseMajSub = this.sse.miseAJourCommande$.subscribe((maj) => {
      if (maj?.commandeId && this.commandeId && maj.commandeId === this.commandeId) {
        this.chargerCommande(this.commandeId);
      }
    });
  }

  chargerDonneesReference() {
    const tousTypes = this.referenceDataService.enumVersOptions(TypeEnvoi);

    if (this.modeCommande === 'urbain') {
      this.typeEnvoiOptions = tousTypes.filter(o => (TYPE_ENVOI_URBAIN as string[]).includes(o.value));
    } else if (this.modeCommande === 'interurbain') {
      this.typeEnvoiOptions = tousTypes.filter(o => (TYPE_ENVOI_INTERURBAIN as string[]).includes(o.value));
    } else {
      this.typeEnvoiOptions = tousTypes;
    }

    this.modePaiementOptions = this.referenceDataService.enumVersOptions(ModePaiement);
    this.moyenTransportOptions = this.referenceDataService.enumVersOptions(MoyenTransport);
  }

  private chargerClients(): void {
    const source$ = this.utilisateurService.obtenirTousUtilisateurs();

    source$.subscribe({
      next: (users: any[]) => {
        this.clientsOptions = (users || []).filter((u: any) => {
          const type = (u?.typeUtilisateurLibelle || u?.typeUtilisateur || '').toString().toUpperCase();
          return type.includes('CLIENT');
        });
        this.clientsFiltres = [...this.clientsOptions];
        const clientId = this.commandeForm?.get('clientId')?.value;
        if (clientId) {
          this.clientSelectionne = this.clientsOptions.find((c: any) => Number(c?.id) === Number(clientId)) || null;
        }
      },
      error: () => {
        this.clientsOptions = [];
        this.clientsFiltres = [];
      }
    });
  }

  toggleDropdownClient(event: Event): void {
    event.stopPropagation();
    this.dropdownClientOuvert = !this.dropdownClientOuvert;
    if (this.dropdownClientOuvert) {
      this.rechercheClient = '';
      this.clientsFiltres = [...this.clientsOptions];
    }
  }

  fermerDropdownClient(): void {
    this.dropdownClientOuvert = false;
  }

  filtrerClients(): void {
    const q = this.rechercheClient.toLowerCase().trim();
    this.clientsFiltres = q
      ? this.clientsOptions.filter((c: any) =>
          `${c.nom} ${c.prenom} ${c.typeUtilisateurLibelle || c.typeUtilisateur || ''}`.toLowerCase().includes(q))
      : [...this.clientsOptions];
  }

  selectionnerClient(client: any): void {
    this.clientSelectionne = client;
    this.commandeForm.patchValue({ clientId: client.id });
    this.dropdownClientOuvert = false;
    this.rechercheClient = '';
    this.modeDescriptionLibre = false;
    this.descriptionLibreTexte = '';
  }

  effacerClient(event: Event): void {
    event.stopPropagation();
    this.clientSelectionne = null;
    this.commandeForm.patchValue({ clientId: '' });
    this.modeDescriptionLibre = false;
    this.descriptionLibreTexte = '';
  }

  libelleClient(client: any): string {
    const type = (client?.typeUtilisateurLibelle || client?.typeUtilisateur || '').toString();
    return `${client.nom || ''} ${client.prenom || ''}`.trim() + (type ? ` — ${type}` : '');
  }

  @HostListener('document:click')
  onDocumentClick(): void {
    this.dropdownClientOuvert = false;
  }

  private ecouterClientSelection(): void {
    this.commandeForm.get('clientId')?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((id) => {
      this.clientSelectionne = this.clientsOptions.find((c: any) => Number(c?.id) === Number(id)) || null;
      const type = this.typeClientSelectionne();
      if (type !== 'CLIENT SOUS CONTRAT') {
        this.commandeForm.patchValue({
          contratBaseTarification: '',
          contratTarificationParticuliere: ''
        }, { emitEvent: false });
      }
    });
  }

  typeClientSelectionne(): string {
    return (this.clientSelectionne?.typeUtilisateurLibelle || this.clientSelectionne?.typeUtilisateur || '').toString().toUpperCase();
  }

  estClientParticuliere(): boolean {
    return (this.clientSelectionne?.contratBaseTarification || '').toString().toUpperCase() === 'PARTICULIERE';
  }

  declencherUploadPhoto(
    cle: string,
    elRecup: HTMLInputElement,
    elExpedition: HTMLInputElement,
    elReception: HTMLInputElement,
    elLivraison: HTMLInputElement
  ): void {
    const map: Record<string, HTMLInputElement> = {
      photoRecuperation: elRecup,
      photoExpeditionCentre: elExpedition,
      photoReceptionCentre: elReception,
      photoLivraison: elLivraison,
    };
    map[cle]?.click();
  }

  onFichierProcessSelectionne(etape: 'RECUPERATION' | 'EXPEDITION_CENTRE' | 'RECEPTION_CENTRE' | 'LIVRAISON', event: Event): void {
    const input = event.target as HTMLInputElement;
    this.fichiersProcess[etape] = input?.files?.[0] ?? null;
  }

  uploaderPhotoProcess(etape: 'RECUPERATION' | 'EXPEDITION_CENTRE' | 'RECEPTION_CENTRE' | 'LIVRAISON'): void {
    if (!this.commandeId) {
      this.toastService.erreur("Enregistrez d'abord la commande.");
      return;
    }
    const file = this.fichiersProcess[etape];
    if (!file) {
      this.toastService.erreur('Sélectionnez une photo.');
      return;
    }
    this.uploadProcessEnCours[etape] = true;
    this.commandeService.uploadPhotoProcess(this.commandeId, etape, file).subscribe({
      next: (res) => {
        this.uploadProcessEnCours[etape] = false;
        this.fichiersProcess[etape] = null;
        this.commandeDetail = res;
        this.toastService.succes('Photo de preuve enregistrée');
        this.chargerCommande(this.commandeId!);
      },
      error: (e) => {
        this.uploadProcessEnCours[etape] = false;
        this.toastService.erreur(this.messageService.afficherMessageErreur(e));
      }
    });
  }

  estInterurbainStandardSelectionne(): boolean {
    const type = (this.commandeForm?.get('typeEnvoi')?.value || this.commandeDetail?.typeEnvoi || '').toString().toUpperCase();
    return type === 'STANDARD_INTERURBAIN';
  }

  estInterurbainExpressSelectionne(): boolean {
    const type = (this.commandeForm?.get('typeEnvoi')?.value || this.commandeDetail?.typeEnvoi || '').toString().toUpperCase();
    return type === 'EXPRESS_INTERURBAIN';
  }

  chargerTarifConfiguration() {
    this.tarifConfigurationService.obtenirTarifConfiguration().subscribe(
      (reponse) => {
        this.tarifConfigurationDTO = reponse;
      }
    );
  }

  contact (operation: string, type: string) {
    let nomAffiche: string;

    if(type == 'Expéditeur') {
      this.contactData = this.expediteur;
      nomAffiche = 'Expéditeurs';
    } else {
      this.contactData = this.destinataire;
      nomAffiche = 'Destinataires';
    }

    if(operation == 'ajout' || operation == 'modif') {
      let dialogRef : any;

      if(type == 'Expéditeur') {
        dialogRef = this.dialog.open(ExpediteurpopupComponent, {
          data: { typeOperation: operation, contact : this.contactData }
        });
      } else {
        dialogRef = this.dialog.open(DestinatairepopupComponent, {
          data: { typeOperation: operation, contact : this.contactData }
        });
      }

      dialogRef.afterClosed().subscribe(resultat => {
        if(type == 'Expéditeur') {
          this.afficherExpediteur(resultat);
        } else {
          this.afficherDestinataire(resultat);
        }
      });
    } else if(operation == 'rech') {
      let idUtilisateur = this.authService.infosUtilisateur.userid;

      if(idUtilisateur == 0 || idUtilisateur == undefined) {
        this.router.navigate(['']);
      } else {
        let dialogRef = this.dialog.open(ListepopupComponent, {
          data: { dataName: type, dataNameDisplayed: nomAffiche, dataRechCol: "Nom, Prémons, N° de Téléphone ou Adresse",
            displayedColumns: this.colonnesContactsAffichees
          }
        });

        dialogRef.afterClosed().subscribe(resultat => {
          if (resultat) {
            if(type == 'Expéditeur') {
              this.afficherExpediteur(resultat);
            } else {
              this.afficherDestinataire(resultat);
            }
          }
        });
      }
    }
  }

  afficherExpediteur(expediteur: ExpediteurDto) {
    if(expediteur.id == undefined || expediteur.nom == undefined ||
      expediteur.prenom == undefined || expediteur.telephone == undefined) return;

    this.commandeForm.patchValue({ expediteurid: expediteur.id });
    this.commandeForm.patchValue({ expediteurNom: expediteur.nom + ' ' + expediteur.prenom });
    this.commandeForm.patchValue({ expediteurContact: expediteur.telephone });
    //this.commandeForm.patchValue({ lieuDepartTexte: this.commandeService.lieuDepartTexte });

    this.commandeForm.value['expediteurid'] = expediteur.id;
    this.commandeForm.value['expediteurNom'] = expediteur.nom + ' ' + expediteur.prenom;
    this.commandeForm.value['expediteurContact'] = expediteur.telephone;

    this.expediteur.id = expediteur.id;
    this.expediteur.nom = expediteur.nom;
    this.expediteur.prenom = expediteur.prenom;
    this.expediteur.telephone = expediteur.telephone;
    this.expediteur.userId = expediteur.userId;
  }

  afficherDestinataire(destinataire: DestinataireDto) {
    if(destinataire.id == undefined || destinataire.nom == undefined ||
      destinataire.prenom == undefined || destinataire.telephone == undefined) return;

    this.commandeForm.patchValue({ destinataireid: destinataire.id });
    this.commandeForm.patchValue({ destinataireNom: destinataire.nom + ' ' + destinataire.prenom });
    this.commandeForm.patchValue({ destinataireContact: destinataire.telephone });
    //this.commandeForm.patchValue({ lieuArriveeTexte: this.commandeService.lieuArriveeTexte });

    this.commandeForm.value['destinataireid'] = destinataire.id;
    this.commandeForm.value['destinataireNom'] = destinataire.nom + ' ' + destinataire.prenom;
    this.commandeForm.value['destinataireContact'] = destinataire.telephone;
    //this.commandeForm.value['lieuArriveeTexte'] = this.commandeService.lieuArriveeTexte;

    this.destinataire.id = destinataire.id;
    this.destinataire.nom = destinataire.nom;
    this.destinataire.prenom = destinataire.prenom;
    this.destinataire.telephone = destinataire.telephone;
    this.destinataire.userId = destinataire.userId;
  }

  rechAdresse (type: string) {
    let dialogRef = this.dialog.open(AdressesListepopupComponent, {
      width: '95vw', maxWidth: '850px', data: type, panelClass: 'address-search-dialog'
    });

    dialogRef.afterClosed().subscribe(resultat => {
      if (!resultat) return;
      const adresse = resultat.address || this.formaterCoordonnees(resultat.latitude, resultat.longitude);
      if(type != 'de livraison') {
        this.commandeForm.patchValue({
          lieuDepartTexte: adresse,
          lieuDepartLongitude: resultat.longitude,
          lieuDepartLatitude: resultat.latitude
        });
      } else {
        this.commandeForm.patchValue({
          lieuArriveeTexte: adresse,
          lieuArriveeLongitude: resultat.longitude,
          lieuArriveeLatitude: resultat.latitude
        });
      }
      // Recherche d'adresse => mode coordonnées (pas mode trajet)
      this.activerModeCoordonnees();
    });
  }

  rechTrajet() {
    const dialogRef = this.dialog.open(ListepopupComponent, {
      data: {
        dataName: 'TrajetsParZone', dataNameDisplayed: 'Trajets',
        dataRechCol: "Zone de départ, Zone de destination, Distance", displayedColumns: this.colonnesTrajetsAffichees
      }
    });

    dialogRef.afterClosed().subscribe(resultat => {
      if (resultat) {
        this.commandeForm.patchValue({ trajetId: resultat.id });
        this.commandeForm.patchValue({ lieuDepartTexte: resultat.zoneDepartNom });
        this.commandeForm.patchValue({ lieuArriveeTexte: resultat.zoneDestinationNom });
        this.trajetLibelle = `${resultat.zoneDepartNom || ''} → ${resultat.zoneDestinationNom || ''} (${resultat.distanceKm ?? 0} km)`;
        // Trajet sélectionné => mode trajet (on évite toute ambiguïté avec des coords GPS)
        this.activerModeTrajet();
      }
    });
  }

  private ecouterTypeEnvoi(): void {
    this.commandeForm.get('typeEnvoi')?.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe((typeEnvoi: string | null) => {
        if (this.estTypeInterurbain(typeEnvoi)) {
          this.commandeForm.patchValue({ flgTarifParZone: true });
          return;
        }
        this.commandeForm.patchValue({
          flgTarifParZone: false,
          trajetId: 0.0
        });
        this.trajetLibelle = '';
      });
  }

  estTypeInterurbain(typeEnvoi?: string | null): boolean {
    const valeur = (typeEnvoi ?? this.commandeForm?.get('typeEnvoi')?.value ?? '').toString().toUpperCase();
    return valeur.includes('INTERURBAIN');
  }

  menuBarreLateraleActif:boolean=false;
  maFonction(){
    if(this.menuBarreLateraleActif==false){
      this.menuBarreLateraleActif=true;
    }
    else {
      this.menuBarreLateraleActif=false;
    }
  }

  ouvrirCarte(type: string) {
    const dialogRef = this.dialog.open(MapDialogComponent, {
      width: '95vw', maxWidth: '600px',
      data: { type },
      panelClass: 'map-picker-dialog'
    });

    dialogRef.afterClosed().subscribe(resultat => {
      if (!resultat) return;
      const coordsTexte = resultat.coordinatesText || this.formaterCoordonnees(resultat.lat, resultat.lng);
      if(type == 'Expéditeur') {
        this.commandeForm.patchValue({
          lieuDepartTexte: coordsTexte,
          lieuDepartLongitude: resultat.lng,
          lieuDepartLatitude: resultat.lat
        });
      } else {
        this.commandeForm.patchValue({
          lieuArriveeTexte: coordsTexte,
          lieuArriveeLongitude: resultat.lng,
          lieuArriveeLatitude: resultat.lat
        });
      }
      // Sélection carte => mode coordonnées (pas mode trajet)
      this.activerModeCoordonnees();
    });
  }

  /**
   * Convertit une heure renvoyée par l'API ({hour,minute,second,nano} ou "HH:mm[:ss]")
   * en chaîne "HH:mm" exploitable par <input type="time">.
   */
  private formaterHeureDepuisApi(heure: any): string | null {
    if (heure == null) return null;
    if (typeof heure === 'string') {
      const m = heure.match(/^(\d{1,2}):(\d{2})/);
      if (!m) return null;
      return `${m[1].padStart(2, '0')}:${m[2]}`;
    }
    if (typeof heure === 'object') {
      const h = (heure.hour ?? 0).toString().padStart(2, '0');
      const m = (heure.minute ?? 0).toString().padStart(2, '0');
      return `${h}:${m}`;
    }
    return null;
  }

  private extraireHeureDepuisDate(dateValeur: any): string | null {
    if (!dateValeur) return null;
    if (typeof dateValeur === 'string') {
      const isoMatch = dateValeur.match(/T(\d{2}):(\d{2})/);
      if (isoMatch) return `${isoMatch[1]}:${isoMatch[2]}`;
      const heureMatch = dateValeur.match(/^(\d{1,2}):(\d{2})/);
      if (heureMatch) return `${heureMatch[1].padStart(2, '0')}:${heureMatch[2]}`;
      return null;
    }
    const dateObj = new Date(dateValeur);
    if (Number.isNaN(dateObj.getTime())) return null;
    const h = `${dateObj.getHours()}`.padStart(2, '0');
    const m = `${dateObj.getMinutes()}`.padStart(2, '0');
    return `${h}:${m}`;
  }

  /**
   * Convertit la valeur d'un <input type="time"> ("HH:mm") en payload accepté par l'API
   * (Spring/Jackson lit nativement "HH:mm:ss" en LocalTime).
   */
  private formaterHeurePourApi(heure: any): string | null {
    if (heure == null || heure === '') return null;
    if (typeof heure !== 'string') return null;
    const m = heure.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?$/);
    if (!m) return null;
    const hh = m[1].padStart(2, '0');
    const mm = m[2];
    const ss = m[3] ?? '00';
    return `${hh}:${mm}:${ss}`;
  }

  private formaterCoordonnees(lat: number, lng: number): string {
    const latSafe = Number.isFinite(lat) ? Number(lat).toFixed(6) : '0.000000';
    const lngSafe = Number.isFinite(lng) ? Number(lng).toFixed(6) : '0.000000';
    return `Lat: ${latSafe}, Lng: ${lngSafe}`;
  }

  onSubmit() {
    if (this.commandeForm.invalid) {
      this.toastService.erreur(this.messageService.obtenirErreursValidationFormulaire(this.commandeForm), 'Erreur de saisie');
      return;
    } else {

      if (this.commandeForm.value['dateEnlevementPrev'] == null && this.commandeForm.value['heureEnlevementPrev'] != null) {
        this.toastService.erreur("Date d'Enlèvement Prévisionnelle obligatoire", 'Erreur de saisie');
        return;
      }

      if (this.commandeForm.value['dateEnlevementPrev'] != null && this.commandeForm.value['heureEnlevementPrev'] == null) {
        this.toastService.erreur("Heure d'Enlèvement Prévisionnelle obligatoire", 'Erreur de saisie');
        return;
      }

      
      this.estEnChargement = true;

      const estModeDescLib = this.estClientParticuliere() && this.modeDescriptionLibre;
      let nombreArticles: number = this.articlesCmd.value.length;

      if (!estModeDescLib && nombreArticles == 0) {
        this.toastService.erreur("Aucun article n'a été ajouté à la commande", 'Erreur de saisie');
        this.estEnChargement = false;
        return;
      }

      if (estModeDescLib && !this.descriptionLibreTexte.trim()) {
        this.toastService.erreur('Veuillez saisir la description du colis.', 'Erreur de saisie');
        this.estEnChargement = false;
        return;
      }

      {
        // getRawValue() inclut les champs disabled (expediteurNom, expediteurContact, etc.)
        let valeurFormulaireCommande = this.commandeForm.getRawValue();
        const montantTotalCalcule = estModeDescLib ? 0 : this.calculerGrandTotal();
        this.commandeForm.patchValue({ montantTotal: montantTotalCalcule });
        const payload = {
          ...valeurFormulaireCommande,
          montantTotal: montantTotalCalcule,
          heureEnlevementPrev: this.formaterHeurePourApi(valeurFormulaireCommande.heureEnlevementPrev),
          ...(estModeDescLib ? {
            flgTarificationParticuliere: true,
            descriptionLibreContrat: this.descriptionLibreTexte.trim(),
            articles: []
          } : {})
        };

        this.commandeService.enregistrerCommande(payload).pipe(
          finalize(() => {
            this.estEnChargement = false;
          })
        ).subscribe({
          next: (reponse) => {
            this.voirBtnEnregistrer = false;
            this.commandeForm.patchValue(valeurFormulaireCommande);
            this.toastService.succes('Commande enregistrée avec succès.', 'Succès');
            if (this.modeCommande === 'interurbain') {
              this.router.navigate(['/commande/interurbain']);
            } else {
              this.router.navigate(['/commande/lister']);
            }
          },
          error: (erreur) => {
            this.voirBtnEnregistrer = true;
            this.commandeForm.patchValue(valeurFormulaireCommande);
            this.toastService.erreur(this.messageService.afficherMessageErreur(erreur));
          }
        });
      }
    }
  }

/*   recalculerTotauxApresAjout(article: any): void {
    let montantTotalForfait = this.commandeForm.get('montantTotalForfait')?.value + 
      (Number(article.value['montantForfait']) * Number(article.value['quantite']));

    let montantTotalSupplementaire = this.commandeForm.get('montantTotalSupplementaire')?.value +
    (Number(article.value['montantSupplementaire']) * Number(article.value['quantite']));

    this.commandeForm.patchValue({ montantForfait: montantTotalForfait });

    this.commandeForm.patchValue({ montantTotalForfait: montantTotalForfait });

    this.commandeForm.patchValue({ montantTotalSupplementaire: montantTotalSupplementaire });

    this.commandeForm.patchValue({ longueurDuTrajet: article.value['longueurDuTrajet'] });

    //const articlesFormArray = this.getArticles();
    const articlesFormArray = this.commandeForm?.get('articles') as FormArray;

    articlesFormArray.push(article);
  } */

  onArticleAjoute() {
    const trajetId = this.commandeForm.value['trajetId'];
    if (this.tarifConfigurationDTO.flgTarifParZone && trajetId != null && trajetId !== 0.0) {
      if (!this.trajetOk()) return;
      this.ouvrirPopupAjoutArticle();
      return;
    }
    const departCoordOk = this.coordonneesValides(
      this.commandeForm.value['lieuDepartLatitude'],
      this.commandeForm.value['lieuDepartLongitude']
    );
    const arriveeCoordOk = this.coordonneesValides(
      this.commandeForm.value['lieuArriveeLatitude'],
      this.commandeForm.value['lieuArriveeLongitude']
    );
    if (departCoordOk && arriveeCoordOk && this.localisationOk()) {
      this.ouvrirPopupAjoutArticle();
      return;
    }
    const adresseDepart = (this.commandeForm.value['lieuDepartTexte'] || '').trim();
    const adresseArrivee = (this.commandeForm.value['lieuArriveeTexte'] || '').trim();
    if (!adresseDepart || !adresseArrivee) {
      this.toastService.erreur("Vous devez indiquer les adresses de récupération et de livraison", 'Erreur de saisie');
      return;
    }
    this.estEnChargement = true;
    forkJoin({
      depart: this.sharedUtilsService.resoudreAdresseVersCoordonnees(adresseDepart),
      arrivee: this.sharedUtilsService.resoudreAdresseVersCoordonnees(adresseArrivee)
    }).subscribe({
      next: ({ depart, arrivee }) => {
        this.estEnChargement = false;
        if (!depart || !arrivee) {
          this.toastService.erreur(
            "Impossible de déterminer les coordonnées depuis ces adresses. Utilisez le bouton Carte ou recherchez un trajet.",
            'Erreur de saisie'
          );
          return;
        }
        this.commandeForm.patchValue({
          lieuDepartLatitude: depart.lat,
          lieuDepartLongitude: depart.lng,
          lieuArriveeLatitude: arrivee.lat,
          lieuArriveeLongitude: arrivee.lng,
          flgTarifParZone: false,
          trajetId: 0.0
        });
        this.ouvrirPopupAjoutArticle();
      },
      error: () => {
        this.estEnChargement = false;
        this.toastService.erreur(
          "Erreur lors de la résolution des adresses. Utilisez le bouton Carte ou recherchez un trajet.",
          'Erreur de saisie'
        );
      }
    });
}

  private ouvrirPopupAjoutArticle(): void {
    let dialogRef = this.dialog.open(ArticlepopupComponent, { width: '95vw', maxWidth: '900px', maxHeight: '95vh',
       data: { typeOperation: 'add', titre: 'Ajouter un Article', article: undefined, lieuDepartLongitude: 
        this.commandeForm.value['lieuDepartLongitude'],  lieuDepartLatitude: this.commandeForm.value['lieuDepartLatitude'],
       lieuArriveeLongitude: this.commandeForm.value['lieuArriveeLongitude'],  lieuArriveeLatitude: this.commandeForm.value['lieuArriveeLatitude'],
      nbrArticle: this.commandeForm.value['articles'].length, trajetId: this.commandeForm.value['trajetId'],
      longueurDuTrajet: this.commandeForm.value['longueurDuTrajet'], editingIndex: null }
     });
 
     dialogRef.afterClosed().subscribe(result => {
       if (result) {
        const tableauArticlesFormulaire = this.obtenirArticles;
        tableauArticlesFormulaire.push(result);
          this.commandeForm.patchValue({ longueurDuTrajet: result.value['longueurDuTrajet'] });
       }
     });
  }

  private coordonneesValides(lat: any, lng: any): boolean {
    return lat != null && lng != null && lat !== 0.0 && lng !== 0.0;
  }

  private activerModeTrajet(): void {
    this.commandeForm.patchValue({
      flgTarifParZone: true,
      lieuDepartLongitude: 0.0,
      lieuDepartLatitude: 0.0,
      lieuArriveeLongitude: 0.0,
      lieuArriveeLatitude: 0.0
    });
  }

  private activerModeCoordonnees(): void {
    this.commandeForm.patchValue({
      flgTarifParZone: false,
      trajetId: 0.0
    });
    this.trajetLibelle = '';
  }

  localisationOk() : boolean {
    if (this.commandeForm.value['lieuDepartLongitude'] == 0.0 || this.commandeForm.value['lieuDepartLongitude'] == undefined
      || this.commandeForm.value['lieuDepartLatitude'] == 0.0 || this.commandeForm.value['lieuDepartLatitude'] == undefined) {
      this.toastService.erreur("Vous devez indiquer la localisation de l'expéditeur", 'Erreur de saisie');
      return false;
    }

    if (this.commandeForm.value['lieuArriveeLongitude'] == 0.0 || this.commandeForm.value['lieuArriveeLongitude'] == undefined
      || this.commandeForm.value['lieuArriveeLatitude'] == 0.0 || this.commandeForm.value['lieuArriveeLatitude'] == undefined) {
      this.toastService.erreur("Vous devez indiquer la localisation du destinataire", 'Erreur de saisie');
      return false;
    }

    this.commandeForm.patchValue({ flgTarifParZone: false });
    this.commandeForm.patchValue({ trajetId: 0.0 });
    return true;
  }

  trajetOk() : boolean {
    if (this.commandeForm.value['trajetId'] == null || this.commandeForm.value['trajetId'] == undefined
      || this.commandeForm.value['trajetId'] == 0.0) {
      this.toastService.erreur("Vous devez indiquer le trajet", 'Erreur de saisie');
      return false;
    }

    this.commandeForm.patchValue({ flgTarifParZone: true });
    this.commandeForm.patchValue({ lieuDepartLongitude: 0.0 });
    this.commandeForm.patchValue({ lieuDepartLatitude: 0.0 });
    this.commandeForm.patchValue({ lieuArriveeLongitude: 0.0 });
    this.commandeForm.patchValue({ lieuArriveeLatitude: 0.0 });
    return true;
  }
 
/*   ajouterAuMontantTotal(article: FormGroup) {
    let montantTotalForfait = this.commandeForm.get('montantTotalForfait')?.value +
      (Number(article.value['montantForfait']) * Number(article.value['quantite']));

    let montantTotalSupplementaire = this.commandeForm.get('montantTotalSupplementaire')?.value +
      (Number(article.value['montantSupplementaire']) * Number(article.value['quantite']));

    this.commandeForm.patchValue({ montantForfait: montantTotalForfait });
    this.commandeForm.patchValue({ montantTotalForfait: montantTotalForfait });
    this.commandeForm.patchValue({ montantTotalSupplementaire: montantTotalSupplementaire });
    this.commandeForm.patchValue({ longueurDuTrajet: article.value['longueurDuTrajet'] });


  } */

  onArticleModifie(index: number) {

    let dialogRef = this.dialog.open(ArticlepopupComponent, { width: '95vw', maxWidth: '900px', maxHeight: '95vh',
       data: { typeOperation: 'mod', titre: 'Modifier un Article', article: this.articlesCmd.at(index).value, lieuDepartLongitude: 
        this.commandeForm.value['lieuDepartLongitude'],  lieuDepartLatitude: this.commandeForm.value['lieuDepartLatitude'],
       lieuArriveeLongitude: this.commandeForm.value['lieuArriveeLongitude'],  lieuArriveeLatitude: this.commandeForm.value['lieuArriveeLatitude'],
      nbrArticle: this.commandeForm.value['articles'].length, trajetId: this.commandeForm.value['trajetId'],
      longueurDuTrajet: this.commandeForm.value['longueurDuTrajet'], editingIndex: null }
     });
 
 
     dialogRef.afterClosed().subscribe(result => {
       if (result) {
        if (index != undefined) {

          const dimensionsArticle = `${result.value['longueur'] || 0} x ${result.value['largeur'] || 0}`;
          result.patchValue({ dimensions: dimensionsArticle });
      
          const articlesArray = this.articlesCmd;
          articlesArray.at(index).patchValue(result.value);
      
        }
       }
     });

  }

/* enregistrerArticleModifie(index: number, articleForm: FormGroup) {
  if (index != undefined) {

    const dimensionsArticle = `${articleForm.value['longueur'] || 0} x ${articleForm.value['largeur'] || 0}`;
    articleForm.patchValue({ dimensions: dimensionsArticle });

    const articlesArray = this.articlesCmd;
    articlesArray.at(index).patchValue(articleForm.value);

    //this.deduireDuMontantTotal(index);

    this.ajouterAuMontantTotal(articleForm);

  }
} */

  onArticleSupprime(index: number) {

    //this.deduireDuMontantTotal(index);

    const tableauArticlesFormulaire = this.obtenirArticles;
    tableauArticlesFormulaire.removeAt(index);

    //this.recalculerMontantTotalForfait();
  }

/*   deduireDuMontantTotal(index: number) {
    let formulaireArticles: FormGroup = this.articlesCmd.value[index];

    let montantTotalForfait = this.commandeForm.get('montantTotalForfait')?.value -
      (Number(formulaireArticles['montantForfait']) * Number(formulaireArticles['quantite']));

    let montantTotalSupplementaire = this.commandeForm.get('montantTotalSupplementaire')?.value -
      (Number(formulaireArticles['montantSupplementaire']) * Number(formulaireArticles['quantite']));

    this.commandeForm.patchValue({ montantTotalForfait: montantTotalForfait });
    this.commandeForm.patchValue({ montantTotalSupplementaire: montantTotalSupplementaire });
  } */

  get obtenirArticles(): FormArray {
    return this.commandeForm?.get('articles') as FormArray;
  }

private surveillanceArticle(): void {

  this.obtenirArticles.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.recalculerMontantTotalForfait();
      });
}

private recalculerMontantTotalForfait(): void {
  //MAJ montantTotalForfait
  const totalForfait = this.obtenirArticles.controls.reduce((somme, articleCtrl) => {
    const montantForfait = Number(articleCtrl.get('montantForfait')?.value) || 0;
    const quantite = Number(articleCtrl.get('quantite')?.value) || 0;
    return somme + (montantForfait * quantite);
  }, 0);

  this.commandeForm.patchValue(
    { montantTotalForfait: totalForfait },
    { emitEvent: false }
  );

//MAJ montantTotalSupplementaire
  const totalSupplementaire = this.obtenirArticles.controls.reduce((somme, articleCtrl) => {
    const montantSupplementaire = Number(articleCtrl.get('montantSupplementaire')?.value) || 0;
    const quantite = Number(articleCtrl.get('quantite')?.value) || 0;
    return somme + (montantSupplementaire * quantite);
  }, 0);

  this.commandeForm.patchValue(
    { montantTotalSupplementaire: totalSupplementaire },
    { emitEvent: false }
  );
  this.commandeForm.patchValue(
    { montantTotal: this.calculerGrandTotal() },
    { emitEvent: false }
  );
}

private surveillerRemise(): void {
  this.commandeForm.get('montantRemise')?.valueChanges
    .pipe(takeUntil(this.destroy$))
    .subscribe(() => {
      this.commandeForm.patchValue(
        { montantTotal: this.calculerGrandTotal() },
        { emitEvent: false }
      );
    });
}

private calculerGrandTotal(): number {
  const forfait = Number(this.commandeForm.value['montantTotalForfait']) || 0;
  const supplementaire = Number(this.commandeForm.value['montantTotalSupplementaire']) || 0;
  const remise = Number(this.commandeForm.value['montantRemise']) || 0;
  return Math.max(0, forfait + supplementaire - remise);
}



  chargerCommande(idCommande: number): void {
    this.commandeService.obtenirCommande(idCommande).subscribe({
      next: (commande: any) => {
        this.commandeDetail = commande;
        this.photoLivraisonErreurChargement = false;
        const heureEnlevementFormatee =
          this.formaterHeureDepuisApi(commande.heureEnlevementPrev) ||
          this.extraireHeureDepuisDate(commande.dateEnlevementPrev);

        this.commandeForm.patchValue({
          dateEnlevementPrev: commande.dateEnlevementPrev,
          heureEnlevementPrev: heureEnlevementFormatee,
          observations: commande.observations,
          expediteurid: commande.expediteurId || 0,
          lieuDepartLongitude: commande.lieuDepartLongitude,
          lieuDepartLatitude: commande.lieuDepartLatitude,
          destinataireid: commande.destinataireId || 0,
          clientId: commande.clientId || null,
          flgTarifParZone: commande.flgTarifParZone,
          lieuArriveeLongitude: commande.lieuArriveeLongitude,
          lieuArriveeLatitude: commande.lieuArriveeLatitude,
          trajetId: commande.trajetId || null,
          longueurDuTrajet: commande.longueurDuTrajet,
          typeEnvoi: commande.typeEnvoi,
          modePaiement: commande.modePaiement,
          moyenTransport: commande.moyenTransport,
          montantTotalForfait: commande.montantTotalForfait,
          montantTotalSupplementaire: commande.montantTotalSupplementaire,
          montantRemise: 0,
          montantTotal: commande.montantTotal,
          statut: commande.statut
        });

        this.commandeForm.patchValue({
          expediteurNom: commande.expediteurNom || '',
          expediteurContact: commande.expediteurContact || '',
          destinataireNom: commande.destinataireNom || '',
          destinataireContact: commande.destinataireContact || ''
        });

        this.commandeForm.get('lieuDepartTexte')?.setValue(commande.lieuDepartTexte);
        this.commandeForm.get('lieuArriveeTexte')?.setValue(commande.lieuArriveeTexte);

        if (commande.trajetZoneDepartNom || commande.trajetZoneDestinationNom) {
          this.trajetLibelle = `${commande.trajetZoneDepartNom || ''} → ${commande.trajetZoneDestinationNom || ''}`;
        } else if (commande.trajet) {
          const t = commande.trajet;
          this.trajetLibelle = `${t.zoneDepartNom || t.zoneDepart?.nom || ''} → ${t.zoneDestinationNom || t.zoneDestination?.nom || ''}`;
        } else {
          this.trajetLibelle = '';
        }

        // Peupler les objets locaux expediteur/destinataire depuis les champs plats du DTO
        if (commande.expediteurId || commande.expediteurNom) {
          this.expediteur = {
            id: commande.expediteurId || undefined,
            nom: commande.expediteurNom || '',
            prenom: '',
            telephone: commande.expediteurContact || ''
          };
        }
        if (commande.destinataireId || commande.destinataireNom) {
          this.destinataire = {
            id: commande.destinataireId || undefined,
            nom: commande.destinataireNom || '',
            prenom: '',
            telephone: commande.destinataireContact || ''
          };
        }

        // Pré-sélectionner le client dans le dropdown
        if (commande.clientId && this.clientsOptions.length > 0) {
          this.clientSelectionne = this.clientsOptions.find((c: any) => Number(c?.id) === Number(commande.clientId)) || null;
        } else if (commande.clientId) {
          // Les clients ne sont pas encore chargés — on attend via ecouterClientSelection
          this.commandeForm.patchValue({ clientId: commande.clientId }, { emitEvent: true });
        }

        if (commande.articles && commande.articles.length > 0) {
          const tableauArticles = this.commandeForm.get('articles') as FormArray;
          tableauArticles.clear();

          commande.articles.forEach((article: any) => {
            const dimensions = `${article.longueur || 0} x ${article.largeur || 0}`;

            const groupeArticle = this.fb.group({
              typeArticle: [article.typeArticle || ''],
              typeConditionnement: [article.typeConditionnement || ''],
              description: [article.description || ''],
              dimensions: [dimensions],
              longueur: [article.longueur || 0],
              largeur: [article.largeur || 0],
              hauteur: [article.hauteur || 0],
              poids: [article.poids || 0],
              quantite: [article.quantite || 1],
              prixUnitaire: [article.prixUnitaire || 0],
              montantForfait: [article.montantForfait || 0],
              montantSupplementaire: [article.montantSupplementaire || 0],
              longueurDuTrajet: [article.longueurDuTrajet || 0]
            });
            tableauArticles.push(groupeArticle);
          });
        }

        if (this.estModeConsultation) {
          this.textBody = 'Détails de la Commande';
          this.voirBtnEnregistrer = false;
          this.desactiverFormulaire();
          this.chargerIncidentsCommande(idCommande);
        } else {
          this.textBody = 'Modifier la Commande';
          this.voirBtnEnregistrer = true;
        }
      },
      error: (erreur) => {
        console.error('Erreur lors du chargement de la commande:', erreur);
        this.toastService.erreur('Impossible de charger la commande');
      }
    });
  }

  chargerIncidentsCommande(idCommande: number): void {
    this.incidentsEnChargement = true;
    this.commandeService.obtenirIncidentsParCommande(idCommande).subscribe({
      next: (incidents) => {
        this.incidentsCommande = incidents ?? [];
        this.incidentsEnChargement = false;
      },
      error: () => {
        this.incidentsCommande = [];
        this.incidentsEnChargement = false;
      }
    });
  }

  obtenirClasseStatutIncident(statut: string): string {
    const map: Record<string, string> = {
      'OUVERT': 'incident-badge-ouvert',
      'EN_COURS': 'incident-badge-en-cours',
      'RESOLU': 'incident-badge-resolu',
      'CLOTURE': 'incident-badge-cloture',
      'ANNULE': 'incident-badge-annule'
    };
    return map[statut] ?? 'incident-badge-ouvert';
  }

  obtenirLibelleTypeIncident(type: string): string {
    const map: Record<string, string> = {
      'PRODUIT_ENDOMMAGE': 'Produit endommagé',
      'RETARD_DE_LIVRAISON': 'Retard de livraison',
      'ERREUR_DE_COMMANDE': 'Erreur de commande',
      'QUALITE_DU_SERVICE': 'Qualité du service',
      'AUTRE': 'Autre'
    };
    return map[type] ?? type;
  }

  obtenirProgressionStepper(statut: string): number {
    const map: Record<string, number> = {
      EN_ATTENTE: 0, AFFECTE: 25, EN_PREPARATION: 50, EN_LIVRAISON: 75, LIVRE: 100
    };
    return map[statut] ?? 0;
  }

  obtenirInitialesLivreur(nom: string): string {
    if (!nom) return '?';
    const mots = nom.trim().split(/\s+/);
    if (mots.length === 1) {
      return (mots[0][0] + (mots[0][mots[0].length - 1] || '')).toUpperCase();
    }
    return (mots[0][0] + mots[mots.length - 1][0]).toUpperCase();
  }

  obtenirEtoilesNote(note: number): string[] {
    const etoiles: string[] = [];
    for (let i = 1; i <= 5; i++) {
      etoiles.push(i <= note ? 'filled' : 'empty');
    }
    return etoiles;
  }

  desactiverFormulaire(): void {
    Object.keys(this.commandeForm.controls).forEach(cle => {
      this.commandeForm.get(cle)?.disable();
    });

    const tableauArticles = this.commandeForm.get('articles') as FormArray;
    tableauArticles.controls.forEach(controle => {
      controle.disable();
    });
  }

  activerFormulaireEdition(): void {
    Object.keys(this.commandeForm.controls).forEach(cle => {
      this.commandeForm.get(cle)?.enable();
    });

    const tableauArticles = this.commandeForm.get('articles') as FormArray;
    tableauArticles.controls.forEach(controle => {
      controle.enable();
    });

    this.commandeForm.get('expediteurNom')?.disable();
    this.commandeForm.get('expediteurContact')?.disable();
    this.commandeForm.get('destinataireNom')?.disable();
    this.commandeForm.get('destinataireContact')?.disable();
  }

  peutModifierCommande(): boolean {
    if (!this.commandeDetail) return true;
    const dejaRecuperee = !!this.commandeDetail?.dateEnlevement;
    const statut = this.commandeDetail?.statut;
    const statutFinal = statut === 'EN_LIVRAISON' || statut === 'LIVRE' || statut === 'ANNULE';
    return !dejaRecuperee && !statutFinal;
  }

  activerModeEdition(): void {
    if (!this.peutModifierCommande()) {
      this.toastService.erreur("Modification impossible : le livreur a déjà récupéré la commande.");
      return;
    }
    this.estModeConsultation = false;
    this.textBody = 'Modifier la Commande';
    this.voirBtnEnregistrer = true;
    this.activerFormulaireEdition();
  }

  readonly STATUTS_BLOQUES_ARTICLES = [
    'RECUPERE', 'AU_DEPOT', 'EN_TRI', 'EN_TRANSIT', 'RECEPTIONNE',
    'EN_DISTRIBUTION', 'EN_LIVRAISON', 'LIVRE', 'ANNULE'
  ];

  peutModifierArticles(): boolean {
    if (!this.commandeDetail || !this.commandeId) return false;
    const role = (this.authService.infosUtilisateur?.role || '').toString().toUpperCase();
    if (!['ADMIN', 'MANAGER', 'RESPONSABLE_ZONE'].includes(role)) return false;
    return !this.STATUTS_BLOQUES_ARTICLES.includes(this.commandeDetail?.statut);
  }

  activerEditionArticles(): void {
    this.articlesSnapshot = JSON.parse(JSON.stringify(this.obtenirArticles.value));
    const articlesArray = this.obtenirArticles;
    articlesArray.controls.forEach(ctrl => ctrl.enable());
    this.modeEditionArticles = true;
  }

  annulerEditionArticles(): void {
    const articlesArray = this.obtenirArticles;
    articlesArray.clear();
    this.articlesSnapshot.forEach(a => {
      const grp = this.fb.group({
        typeArticle: [a.typeArticle || ''],
        typeConditionnement: [a.typeConditionnement || ''],
        description: [a.description || ''],
        dimensions: [a.dimensions || ''],
        longueur: [a.longueur || 0],
        largeur: [a.largeur || 0],
        hauteur: [a.hauteur || 0],
        poids: [a.poids || 0],
        quantite: [a.quantite || 1],
        prixUnitaire: [a.prixUnitaire || 0],
        montantForfait: [a.montantForfait || 0],
        montantSupplementaire: [a.montantSupplementaire || 0],
        longueurDuTrajet: [a.longueurDuTrajet || 0]
      });
      grp.disable();
      articlesArray.push(grp);
    });
    this.modeEditionArticles = false;
  }

  sauvegarderArticles(): void {
    if (!this.commandeId) return;
    this.sauvegarderArticlesEnCours = true;
    const articlesPayload = this.obtenirArticles.value.map((a: any) => ({
      typeArticle: a.typeArticle,
      typeConditionnement: a.typeConditionnement,
      description: a.description,
      longueur: a.longueur,
      largeur: a.largeur,
      hauteur: a.hauteur,
      poids: a.poids,
      quantite: a.quantite,
      prixUnitaire: a.prixUnitaire,
      montantForfait: a.montantForfait,
      montantSupplementaire: a.montantSupplementaire,
      longueurDuTrajet: a.longueurDuTrajet,
      trajetId: this.commandeForm.value['trajetId'] || null
    }));
    this.commandeService.mettreAJourArticlesCommande(this.commandeId, articlesPayload).subscribe({
      next: () => {
        this.sauvegarderArticlesEnCours = false;
        this.modeEditionArticles = false;
        this.toastService.succes('Articles mis à jour avec succès.');
        this.chargerCommande(this.commandeId!);
      },
      error: (e) => {
        this.sauvegarderArticlesEnCours = false;
        this.toastService.erreur(this.messageService.afficherMessageErreur(e));
      }
    });
  }

  obtenirLibelle(options: { label: string, value: string }[], value: string): string {
    if (!value) return '—';
    const option = options.find(opt => opt.value === value);
    return option ? option.label : value;
  }

  estLivreur(): boolean {
    const user = this.authService.infosUtilisateur;
    return user && user.role === 'LIVREUR';
  }

  changerStatutLivreur(nouveauStatut: string): void {
    const idCommande = this.commandeForm.value.id;
    if (!idCommande) return;

    this.estEnChargement = true;
    this.commandeService.mettreAJourStatutCommande(idCommande, nouveauStatut).subscribe({
      next: () => {
        this.estEnChargement = false;
        this.toastService.succes(`Statut changé en "${this.obtenirTexteStatut(nouveauStatut)}"`);
        this.commandeForm.patchValue({ statut: nouveauStatut });
      },
      error: (erreur) => {
        this.estEnChargement = false;
        this.toastService.erreur('Erreur lors du changement de statut: ' + this.messageService.afficherMessageErreur(erreur));
      }
    });
  }

  obtenirTexteStatut(statut: string): string {
    const textes: { [key: string]: string } = {
      'EN_ATTENTE': 'Commande enregistrée',
      'AFFECTE': 'Livreur assigné',
      'EN_PREPARATION': 'En route vers le retrait',
      'EN_LIVRAISON': 'Colis en route',
      'LIVRE': 'Livrée',
      'ANNULE': 'Annulée'
    };
    return textes[statut] || statut;
  }

  obtenirClasseStatut(statut: string): string {
    const map: { [key: string]: string } = {
      'EN_ATTENTE':    'statut-attente',
      'AFFECTE':       'statut-affecte',
      'EN_PREPARATION':'statut-preparation',
      'EN_LIVRAISON':  'statut-livraison',
      'LIVRE':         'statut-livre',
      'ANNULE':        'statut-annule',
    };
    return map[statut] || 'statut-attente';
  }

  urlPhoto(path: string | null | undefined): string | null {
    if (!path) return null;
    if (path.startsWith('http')) return path;
    const apiBase = (environment.apiurl || '').replace(/\/api\/v1\/?$/i, '/').replace(/\/api\/?$/i, '/');
    // Compatibilité historique : anciennes URLs enregistrées en "/uploads/commandes/..."
    // alors que les fichiers sont dans "/uploads/dematral/commandes/...".
    let normalizedPath = path.startsWith('/') ? path.substring(1) : path;
    if (normalizedPath.startsWith('uploads/commandes/')) {
      normalizedPath = normalizedPath.replace('uploads/commandes/', 'uploads/dematral/commandes/');
    }
    if (apiBase) return `${apiBase}${normalizedPath}`;
    return `https://${environment.domain}/${normalizedPath}`;
  }

  ouvrirPhotoPleinEcran(path: string): void {
    const url = this.urlPhoto(path);
    if (url) {
      this.photoApercuUrl = url;
      this.photoApercuIndex = -1;
    }
  }

  fermerPhotoPleinEcran(): void {
    this.photoApercuUrl = null;
    this.photoApercuIndex = -1;
  }

  obtenirDatePassage(): string | null {
    return this.commandeDetail?.dateCreation || this.commandeDetail?.dateCommande || null;
  }

  marquerErreurImageLivraison(): void {
    this.photoLivraisonErreurChargement = true;
  }

  photosProcessTimeline(): { cle: string; label: string; obligatoire: boolean; url: string | null }[] {
    const type = (this.commandeDetail?.typeEnvoi || this.commandeForm?.get('typeEnvoi')?.value || '').toString().toUpperCase();
    const interurbainStandard = type === 'STANDARD_INTERURBAIN';
    const interurbainExpress = type === 'EXPRESS_INTERURBAIN';
    const common = [
      { cle: 'photoRecuperation', label: 'Récupération colis', obligatoire: true, url: this.commandeDetail?.photoRecuperation || null },
      { cle: 'photoLivraison', label: 'Preuve livraison destinataire', obligatoire: true, url: this.commandeDetail?.photoLivraison || null }
    ];
    if (interurbainStandard) {
      return [
        common[0],
        { cle: 'photoExpeditionCentre', label: 'Expédition centre départ', obligatoire: true, url: this.commandeDetail?.photoExpeditionCentre || null },
        { cle: 'photoReceptionCentre', label: 'Réception centre destination', obligatoire: true, url: this.commandeDetail?.photoReceptionCentre || null },
        common[1]
      ];
    }
    if (interurbainExpress) {
      return common;
    }
    return common;
  }

  ouvrirPhotoTimeline(index: number): void {
    const etapes = this.photosProcessTimeline().filter((x) => !!x.url);
    if (!etapes.length || index < 0 || index >= etapes.length) {
      return;
    }
    const url = this.urlPhoto(etapes[index].url || '');
    if (!url) return;
    this.photoApercuIndex = index;
    this.photoApercuUrl = url;
  }

  photoTimelinePrecedente(): void {
    const etapes = this.photosProcessTimeline().filter((x) => !!x.url);
    if (!etapes.length) return;
    const next = this.photoApercuIndex <= 0 ? etapes.length - 1 : this.photoApercuIndex - 1;
    this.ouvrirPhotoTimeline(next);
  }

  photoTimelineSuivante(): void {
    const etapes = this.photosProcessTimeline().filter((x) => !!x.url);
    if (!etapes.length) return;
    const next = this.photoApercuIndex >= etapes.length - 1 ? 0 : this.photoApercuIndex + 1;
    this.ouvrirPhotoTimeline(next);
  }

  ouvrirPanelAffectationLivreur(): void {
    const idCommande = this.commandeDetail?.id ?? this.commandeId;
    if (!idCommande) {
      this.toastService.erreur('Commande introuvable pour charger les livreurs.');
      return;
    }
    this.panelAffectationOuvert = true;
    document.body.classList.add('overlay-panel-open');
    this.rechercheLivreur = '';
    this.chargementLivreurs = true;
    this.livreursPanel = [];
    this.livreursPanelFiltres = [];
    this.montantContrat = null;

    this.sharedUtilsService.obtenirLivreursDisponibles(idCommande).subscribe({
      next: (reponse: any) => {
        const liste = Array.isArray(reponse) ? reponse : (reponse?.content ?? []);
        this.livreursPanel = liste;
        this.livreursPanelFiltres = [...liste];
        this.chargementLivreurs = false;
      },
      error: (erreur) => {
        this.chargementLivreurs = false;
        this.livreursPanel = [];
        this.livreursPanelFiltres = [];
        this.toastService.erreur('Impossible de charger les livreurs: ' + this.messageService.afficherMessageErreur(erreur));
      }
    });
  }

  fermerPanelAffectation(): void {
    if (this.assignationEnCours) return;
    this.panelAffectationOuvert = false;
    document.body.classList.remove('overlay-panel-open');
  }

  filtrerLivreursPanel(): void {
    const terme = (this.rechercheLivreur || '').trim().toLowerCase();
    if (!terme) {
      this.livreursPanelFiltres = [...this.livreursPanel];
      return;
    }
    this.livreursPanelFiltres = this.livreursPanel.filter((livreur: any) =>
      `${livreur?.nom || ''} ${livreur?.prenom || ''}`.toLowerCase().includes(terme) ||
      `${livreur?.contact || ''}`.toLowerCase().includes(terme) ||
      `${livreur?.adresse || ''}`.toLowerCase().includes(terme)
    );
  }

  libelleTypeVehicule(livreur: any): string {
    const type = livreur?.vehiculeActuel?.typeVehicule;
    const labels: Record<string, string> = {
      MOTO: '🏍️ Moto',
      CAMION_LEGER: '🚐 Camion léger',
      GROS_CAMION: '🚛 Gros camion',
      CAMION: '🚛 Camion',
      VELO: '🚲 Vélo',
    };
    return labels[type] ?? (type ? type : '');
  }

  assignerLivreurDepuisPanel(livreurChoisi: any): void {
    const idCommande = this.commandeDetail?.id ?? this.commandeId;
    if (!idCommande || !livreurChoisi?.id || this.assignationEnCours) return;

    const estContrat = this.commandeDetail?.flgTarificationParticuliere === true;
    if (estContrat && (this.montantContrat == null || this.montantContrat < 0)) {
      this.toastService.erreur('Veuillez saisir le montant à facturer pour cette commande sous contrat.', 'Montant requis');
      return;
    }

    this.assignationEnCours = true;
    this.sse.ignorerProchainToastAffectationLivreur(idCommande);
    const montant = estContrat ? this.montantContrat! : undefined;
    this.sharedUtilsService.attribuerLivreurManuellement(idCommande, livreurChoisi.id, montant).subscribe({
      next: (updated: any) => {
        this.assignationEnCours = false;
        this.commandeDetail = { ...this.commandeDetail, ...updated };
        this.toastService.succes(`Livreur ${livreurChoisi.nom || ''} ${livreurChoisi.prenom || ''} affecté avec succès`);
        this.panelAffectationOuvert = false;
        document.body.classList.remove('overlay-panel-open');
      },
      error: (err: any) => {
        this.sse.ignorerProchainToastAffectationLivreur(idCommande);
        this.commandeService.obtenirCommande(idCommande).subscribe({
          next: (commandeFraiche: any) => {
            this.assignationEnCours = false;
            this.commandeDetail = commandeFraiche;
            if (commandeFraiche?.livreurId || commandeFraiche?.livreurNom) {
              this.sse.ignorerProchainToastAffectationLivreur(idCommande);
              this.toastService.succes('Livreur affecté avec succès.');
              this.panelAffectationOuvert = false;
              document.body.classList.remove('overlay-panel-open');
              return;
            }
            this.toastService.erreur('Erreur lors de l\'affectation : ' + this.messageService.afficherMessageErreur(err));
          },
          error: () => {
            this.assignationEnCours = false;
            this.toastService.erreur('Erreur lors de l\'affectation : ' + this.messageService.afficherMessageErreur(err));
          }
        });
      }
    });
  }

}
